import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCardImgProcessStatus, getDetailProcessingStatus, searchProcessingStatuses } from "services/ProcessingStatusService";
import { X_TOTAL_COUNT } from "utils/constants";
import { checkDateMonth, dateFormat1, dateFormat2, formatDate, range2 } from "utils/date";
import { handleError } from "utils/handleError";
import { ProcessingStatusCardImg } from "./ProcessingStatusCardImg";
import { ProcessingStatusContext } from "./ProcessingStatusContext";

export const ProcessingStatusList = () => {
    const avatar = process.env.PUBLIC_URL + "/assets/layout/images/avatar.png";
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["processing-status", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const processingStatusContext = useContext(ProcessingStatusContext);
    const { processingStatuses, setProcessingStatuses, cardImg, setCardImg, processingStatusDialog, setProcessingStatusDialog, processingStatus, setProcessingStatus } = processingStatusContext;

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [checkLoad, setCheckLoad] = useState(false);

    const [selectedProcessingStatus, setSelectedProcessingStatus] = useState(null);

    const now = new Date();

    const beforeNow = new Date(new Date().setDate(new Date().getDate() - range2));
    const [formatDateVal, setFormatDateVal] = useState(dateFormat1);

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: "", matchMode: "contains" },
            phoneNumber: { value: "", matchMode: "contains" },
            fullName: { value: "", matchMode: "contains" },
            birthDay: { value: null, matchMode: "equals" },
            fromDate: { value: beforeNow, matchMode: "equals" },
            toDate: { value: now, matchMode: "equals" },
        },
    });

    const regisTypes = [
        { label: "eKYC", value: 1 },
        { label: "Đặt lịch cqca", value: 2 },
        { label: "Thu nhận từ app cán bộ", value: 3 },
        { label: "Hồ sơ đến trực tiếp CQCA", value: 4 },
    ];

    const results = [
        { label: "Từ chối tiếp nhận", value: "-1" },
        { label: "Không được cấp", value: "0" },
        { label: "Được cấp", value: "1" },
        { label: "Không đạt liveness", value: "2" },
    ];

    const ktdcs = [
        { label: "Khai thác dân cư thành công", value: "0" },
        { label: "Khai thác không thành công", value: "1" },
    ];

    const kqliveness = [
        { label: "Không đạt", value: "0" },
        { label: "Đạt", value: "1" },
    ];

    const nfcs = [
        { label: "Hồ sơ không NFC", value: "0" },
        { label: "Hồ sơ có NFC", value: "1" },
    ];

    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);

    useEffect(() => {
        if (selectedProcessingStatus?.id) {
            getDetailProcessingStatus(headers, selectedProcessingStatus.id)
                .then((res) => {
                    setProcessingStatus(res.data);
                })
                .catch((error) => handleError(toast, t, error));

            getCardImgProcessStatus(headers, selectedProcessingStatus.id)
                .then((res) => {
                    setCardImg(res.data);
                })
                .catch((error) => handleError(toast, t, error));
        } else {
            setCardImg(null);
            setProcessingStatus(null);
        }
    }, [selectedProcessingStatus]);

    const loadLazyData = () => {
        setLoading(true);
        searchProcessingStatuses(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                });
                setProcessingStatuses(dataRes);
                if (dataRes?.length > 0) {
                    setSelectedProcessingStatus(dataRes[0]);
                } else {
                    setSelectedProcessingStatus(null);
                }
            })
            // .catch((error) => handleError(toast, t, error))
            .finally(() => setLoading(false));
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const regisTypeTemplateBody = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <p>{regisTypes.find((e) => e.value === rowData.regisType).label}</p>
            </div>
        );
    };

    const ResultTemplateBody = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <p>{results.find((e) => e.value === rowData.result)?.label}</p>
            </div>
        );
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchOption = (
        <>
            <div className="grid">
                {/* Số ĐDCN */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="idNumber"
                        >
                            {t("processing-status.idNumber")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="idNumber"
                                name="idNumber"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            idNumber: {
                                                ...lazyParams.filters.idNumber,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* số điện thoại */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="phoneNumber"
                        >
                            {t("processing-status.phoneNumber")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="phoneNumber"
                                name="phoneNumber"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            phoneNumber: {
                                                ...lazyParams.filters.phoneNumber,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* họ và tên */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "80px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="fullName"
                        >
                            {t("processing-status.fullName")}
                        </label>
                        <div className="col">
                            <InputText
                                style={{
                                    width: "100%",
                                }}
                                id="fullName"
                                name="fullName"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            fullName: {
                                                ...lazyParams.filters.fullName,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText>
                        </div>
                    </div>
                </div>

                {/* ngày sinh */}
                <div className="col-12 md:col-3">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "70px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="birthDay"
                        >
                            {t("processing-status.birthDay")}
                        </label>
                        <div className="col">
                            <Calendar
                                style={{ width: "100%" }}
                                value={lazyParams.filters.birthDay.value}
                                onChange={(e) => {
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            birthDay: {
                                                ...lazyParams.filters.birthDay,
                                                value: e.value,
                                            },
                                        },
                                    });
                                }}
                                onBlur={() => {
                                    setFormatDateVal(dateFormat1);
                                }}
                                onFocus={() => {
                                    setFormatDateVal(dateFormat2);
                                }}
                                name="birthDay"
                                id="birthDay"
                                // maxDate={now}
                                dateFormat={formatDateVal}
                            ></Calendar>
                            {/* <InputText
                                style={{
                                    width: "100%",
                                }}
                                d
                                id="birthDay"
                                name="birthDay"
                                type="date"
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            birthDay: {
                                                ...lazyParams.filters.birthDay,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                {/* Ngày nhận từ */}
                <div className="col-12 md:col-4">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "100px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="fromDate"
                        >
                            {t("processing-status.fromDate")}
                        </label>
                        <div className="col">
                            <Calendar
                                style={{ width: "100%" }}
                                value={lazyParams.filters.fromDate.value}
                                onChange={(e) => {
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            fromDate: {
                                                ...lazyParams.filters.fromDate,
                                                value: e.value,
                                            },
                                        },
                                    });
                                }}
                                onBlur={() => {
                                    setFormatDateVal(dateFormat1);
                                }}
                                onFocus={() => {
                                    setFormatDateVal(dateFormat2);
                                }}
                                name="fromDate"
                                id="fromDate"
                                maxDate={lazyParams.filters.toDate.value}
                                dateFormat={formatDateVal}
                            ></Calendar>
                            {/* <InputText
                                style={{
                                    width: "100%",
                                }}
                                type="date"
                                id="fromDate"
                                name="fromDate"
                                value={lazyParams.filters.fromDate.value}
                                max={lazyParams.filters.toDate.value}
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            fromDate: {
                                                ...lazyParams.filters.fromDate,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText> */}
                        </div>
                    </div>
                </div>

                {/* đến */}
                <div className="col-12 md:col-4">
                    <div className="grid custom-form">
                        <label
                            className="col-fixed text-center"
                            style={{
                                width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                            htmlFor="toDate"
                        >
                            {t("processing-status.toDate")}
                        </label>
                        <div className="col">
                            <Calendar
                                style={{ width: "100%" }}
                                value={lazyParams.filters.toDate.value}
                                onChange={(e) => {
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            toDate: {
                                                ...lazyParams.filters.toDate,
                                                value: e.value,
                                            },
                                        },
                                    });
                                }}
                                onBlur={() => {
                                    setFormatDateVal(dateFormat1);
                                }}
                                onFocus={() => {
                                    setFormatDateVal(dateFormat2);
                                }}
                                name="toDate"
                                id="toDate"
                                // maxDate={now}
                                minDate={lazyParams.filters.fromDate.value}
                                dateFormat={formatDateVal}
                            ></Calendar>
                            {/* <InputText
                                style={{
                                    width: "100%",
                                }}
                                type="date"
                                id="toDate"
                                name="toDate"
                                value={lazyParams.filters.toDate.value}
                                max={now}
                                min={lazyParams.filters.fromDate.value}
                                onChange={(e) => {
                                    setCheckLoad(false);
                                    setLazyParams({
                                        ...lazyParams,
                                        filters: {
                                            ...lazyParams.filters,
                                            toDate: {
                                                ...lazyParams.filters.toDate,
                                                value: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            ></InputText> */}
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-4 text-right">
                    <div className="grid custom-form">
                        <div className="col-12">
                            <label
                                style={{
                                    // width: "130px",
                                    // justifyContent: "end",
                                    display: "flex",
                                    padding: "0.75rem 0px 0px 0px",
                                }}
                            >
                                {" "}
                            </label>
                        </div>
                        <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                            <Button
                                label={t("search", { ns: "common" })}
                                icon="pi pi-search"
                                onClick={(e) => {
                                    if (lazyParams.filters.idNumber.value || lazyParams.filters.phoneNumber.value || (lazyParams.filters.fullName.value && lazyParams.filters.birthDay.value)) {
                                        setCheckLoad(true);
                                        setLazyParams({
                                            ...lazyParams,
                                            first: 0,
                                            page: 0,
                                        });
                                    } else {
                                        if (lazyParams.filters.fromDate.value && lazyParams.filters.toDate.value) {
                                            if (checkDateMonth(lazyParams.filters.fromDate.value, lazyParams.filters.toDate.value, range2)) {
                                                setCheckLoad(true);
                                                setLazyParams({
                                                    ...lazyParams,
                                                    first: 0,
                                                    page: 0,
                                                });
                                            } else {
                                                toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("processing-status.rangeFromToDate"), life: 3000 });
                                            }
                                        } else {
                                            toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("processing-status.requiredfromandtodate"), life: 3000 });
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("processing-status.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>
                    <Toast ref={toast} />
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("processing-status.list")}>
                                <div className="grid">
                                    <div className="col-12">
                                        <DataTable
                                            ref={dt}
                                            value={processingStatuses}
                                            dataKey="stt"
                                            className="datatable-responsive p-datatable-sm"
                                            selectionMode="single"
                                            selection={selectedProcessingStatus}
                                            onSelectionChange={(e) => {
                                                setSelectedProcessingStatus(e.value);
                                            }}
                                            showGridlines
                                            lazy
                                            paginator
                                            rows={lazyParams.rows}
                                            first={lazyParams.first}
                                            totalRecords={totalRecords}
                                            onPage={onPage}
                                            onSort={onSort}
                                            sortField={lazyParams.sortField}
                                            sortOrder={lazyParams.sortOrder}
                                            onFilter={onFilter}
                                            filters={lazyParams.filters}
                                            loading={loading}
                                            paginatorClassName="justify-content-start"
                                            paginatorTemplate={paginatorTemplate}
                                            emptyMessage="Không có dữ liệu"
                                            scrollable
                                        >
                                            <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                            <Column field="idNumber" header={t("processing-status.idNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                            <Column field="fullName" header={t("processing-status.fullName")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                            <Column field="birthDate" header={t("processing-status.birthDate")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                            <Column field="gender" header={t("processing-status.gender")} style={{ minWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                            <Column field="docCode" header={t("processing-status.docCode")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />

                                            <Column field="regisType" header={t("processing-status.regisType")} body={regisTypeTemplateBody} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                            <Column field="result" header={t("processing-status.result")} body={ResultTemplateBody} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                        </DataTable>
                                    </div>
                                </div>

                                {processingStatus && (
                                    <div className="formgrid mt-2">
                                        <div className="grid">
                                            <div className="col-12">
                                                <div className="grid">
                                                    <div className="col-fixed" style={{ width: "200px" }}>
                                                        <img src={processingStatus.portraitImage ? `data:image/jpeg;base64,${processingStatus.portraitImage}` : avatar} width="100%" height={"300px"} alt="" style={{ border: "1px solid #ced4da" }}></img>
                                                    </div>
                                                    <div className="col">
                                                        <div className="grid">
                                                            <div className="col-12">
                                                                <div className="grid">
                                                                    {/* Số điện thoại */}
                                                                    <div className="field col-12 md:col-3">
                                                                        <label htmlFor="phoneNumber" className="custom-form">
                                                                            {t("processing-status.phoneNumber")}
                                                                        </label>
                                                                        <InputText tooltip={processingStatus.phoneNumber} name="phoneNumber" id="phoneNumber" value={processingStatus.phoneNumber} tooltipOptions={{ position: "top" }} className="custom-form" readOnly={true} />
                                                                    </div>

                                                                    {/* email */}
                                                                    <div className="field col-12 md:col-3">
                                                                        <label htmlFor="email" className="custom-form">
                                                                            {t("processing-status.email")}
                                                                        </label>
                                                                        <InputText name="email" id="email" tooltip={processingStatus.email} value={processingStatus.email} tooltipOptions={{ position: "top" }} readOnly={true} className="custom-form" />
                                                                    </div>

                                                                    <div className="field col-12 md:col-3">
                                                                        <label htmlFor="bloodGroup" className="custom-form">
                                                                            {t("processing-status.bloodGroup")}
                                                                        </label>
                                                                        <InputText name="bloodGroup" id="bloodGroup" tooltip={processingStatus.bloodGroup} value={processingStatus.bloodGroup} tooltipOptions={{ position: "top" }} readOnly={true} className="custom-form" />
                                                                    </div>

                                                                    <div className="field col-12 md:col-3">
                                                                        <label htmlFor="ethnic" className="custom-form">
                                                                            {t("processing-status.ethnic")}
                                                                        </label>
                                                                        <InputText name="ethnic" id="ethnic" tooltip={processingStatus.ethnic} value={processingStatus.ethnic} tooltipOptions={{ position: "top" }} readOnly={true} className="custom-form" />
                                                                    </div>
                                                                </div>

                                                                <div className="grid">
                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="religion" className="custom-form">
                                                                            {t("processing-status.religion")}
                                                                        </label>
                                                                        <InputText name="religion" id="religion" tooltipOptions={{ position: "top" }} tooltip={processingStatus.religion} value={processingStatus.religion} readOnly={true} className="custom-form" />
                                                                    </div>

                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="nationality" className="custom-form">
                                                                            {t("processing-status.nationality")}
                                                                        </label>
                                                                        <InputText name="nationality" tooltip={processingStatus.nationality} id="nationality" value={processingStatus.nationality} tooltipOptions={{ position: "top" }} readOnly={true} className="custom-form" />
                                                                    </div>

                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="mariedStatus" className="custom-form">
                                                                            {t("processing-status.mariedStatus")}
                                                                        </label>
                                                                        <InputText name="mariedStatus" tooltip={processingStatus.mariedStatus} id="mariedStatus" value={processingStatus.mariedStatus} tooltipOptions={{ position: "top" }} className="custom-form" readOnly={true} />
                                                                    </div>
                                                                </div>

                                                                <div className="grid">
                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="hometown" className="custom-form">
                                                                            {t("processing-status.hometown")}
                                                                        </label>
                                                                        <InputText name="hometown" id="hometown" tooltip={processingStatus.hometown} value={processingStatus.hometown} tooltipOptions={{ position: "top" }} readOnly={true} className="custom-form" />
                                                                    </div>

                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="address" className="custom-form">
                                                                            {t("processing-status.address")}
                                                                        </label>
                                                                        <InputText name="address" id="address" tooltip={processingStatus.address} value={processingStatus.address} tooltipOptions={{ position: "top" }} readOnly={true} className="custom-form" />
                                                                    </div>

                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="birdPlace" className="custom-form">
                                                                            {t("processing-status.birdPlace")}
                                                                        </label>
                                                                        <InputText name="birdPlace" id="birdPlace" tooltip={processingStatus.birdPlace} value={processingStatus.birdPlace} tooltipOptions={{ position: "top" }} readOnly={true} className="custom-form" />
                                                                    </div>
                                                                </div>

                                                                <div className="grid">
                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="hometownForeign" className="custom-form">
                                                                            {t("processing-status.hometownForeign")}
                                                                        </label>
                                                                        <InputText name="hometownForeign" id="hometownForeign" tooltip={processingStatus.hometownForeign} value={processingStatus.hometownForeign} readOnly={true} className="custom-form" tooltipOptions={{ position: "top" }} />
                                                                    </div>

                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="unitReceipt" className="custom-form">
                                                                            {t("processing-status.unitReceipt")}
                                                                        </label>
                                                                        <InputText name="unitReceipt" id="unitReceipt" tooltip={processingStatus.unitReceipt} value={processingStatus.unitReceipt} tooltipOptions={{ position: "top" }} readOnly={true} className="custom-form" />
                                                                    </div>

                                                                    <div className="field col-12 md:col-4">
                                                                        <label htmlFor="dateReceipt" className="custom-form">
                                                                            {t("processing-status.dateReceipt")}
                                                                        </label>
                                                                        <InputText name="dateReceipt" id="dateReceipt" value={processingStatus.dateReceipt} readOnly={true} className="custom-form" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="fatherName" className="custom-form">
                                                            {t("processing-status.fatherName")}
                                                        </label>
                                                        <InputText name="fatherName" id="fatherName" value={processingStatus.fatherName} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="fatherIdNumber" className="custom-form">
                                                            {t("processing-status.fatherIdNumber")}
                                                        </label>
                                                        <InputText name="fatherIdNumber" id="fatherIdNumber" value={processingStatus.fatherIdNumber} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="fatherNationality" className="custom-form">
                                                            {t("processing-status.fatherNationality")}
                                                        </label>
                                                        <InputText name="fatherNationality" id="fatherNationality" value={processingStatus.fatherNationality} className="custom-form" readOnly={true} />
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="motherName" className="custom-form">
                                                            {t("processing-status.motherName")}
                                                        </label>
                                                        <InputText name="motherName" id="motherName" value={processingStatus.motherName} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="motherIdNumber" className="custom-form">
                                                            {t("processing-status.motherIdNumber")}
                                                        </label>
                                                        <InputText name="motherIdNumber" id="motherIdNumber" value={processingStatus.motherIdNumber} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="motherNationality" className="custom-form">
                                                            {t("processing-status.motherNationality")}
                                                        </label>
                                                        <InputText name="motherNationality" id="motherNationality" value={processingStatus.motherNationality} className="custom-form" readOnly={true} />
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="mateName" className="custom-form">
                                                            {t("processing-status.mateName")}
                                                        </label>
                                                        <InputText name="mateName" id="mateName" value={processingStatus.mateName} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="mateIdNumber" className="custom-form">
                                                            {t("processing-status.mateIdNumber")}
                                                        </label>
                                                        <InputText name="mateIdNumber" id="mateIdNumber" value={processingStatus.mateIdNumber} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="mateNationality" className="custom-form">
                                                            {t("processing-status.mateNationality")}
                                                        </label>
                                                        <InputText name="mateNationality" id="mateNationality" value={processingStatus.mateNationality} className="custom-form" readOnly={true} />
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    <div className="field col-12 md:col-6">
                                                        <label htmlFor="reason" className="custom-form">
                                                            {t("processing-status.reason")}
                                                        </label>
                                                        <InputText name="reason" id="reason" tooltip={processingStatus.reason} tooltipOptions={{ position: "top" }} value={processingStatus.reason} className="custom-form" readOnly={true} />
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    {/* khai thác dân cư */}
                                                    <div className="field col-12 md:col-2">
                                                        <label htmlFor="isResident" className="custom-form">
                                                            {t("processing-status.isResident")}
                                                        </label>
                                                        <InputText name="isResident" id="isResident" value={ktdcs.find((e) => e.value == processingStatus.isResident)?.label} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div className="field col-12 md:col-2">
                                                        <label htmlFor="resultLiveness" className="custom-form">
                                                            {t("processing-status.resultLiveness")}
                                                        </label>
                                                        <InputText name="resultLiveness" id="resultLiveness" value={kqliveness.find((e) => e.value == processingStatus.resultLiveness)?.label} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div className="field col-12 md:col-2">
                                                        <label htmlFor="isNfc" className="custom-form">
                                                            {t("processing-status.isNfc")}
                                                        </label>
                                                        <InputText name="isNfc" id="isNfc" value={nfcs.find((e) => e.value == processingStatus.isNfc)?.label} className="custom-form" readOnly={true} />
                                                    </div>

                                                    <div style={{ margin: "auto", textAlign: "center" }} className="field col-12 md:col-6">
                                                        <Button
                                                            label={t("processing-status.viewCardImg")}
                                                            onClick={(e) => {
                                                                setProcessingStatusDialog(true);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </BlockDetail>
                        </div>
                    </div>

                    <ProcessingStatusCardImg />
                </div>
            </div>
        </div>
    );
};
